export default __webpack_public_path__ + "static/media/humidity.97e10e41.png";